import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import URL from '@/store/url'

Vue.use(Vuex)

const state = {
  isLogin: false,
  studentInfo: {},
  questionnaireId: null, // 量表组合列表id
  questionnaireList: null, // 量表组合列表
  scaleList: null, // 单个量表组合详细信息
  isFresh: false,
  navState: true,
  navIndex: 0,
  isShowTalk: true, // 石否显示悄悄话组建
  promptShow: false,
  checkDate: true,
  isViewBox: false,
  errMsg: '',
  navList: [
    {
      title: '平台首页',
      router: '/homeView'
    },
    {
      title: '已购套餐',
      router: '/scalePlan'
    },
    {
      title: '绑定兑换码',
      router: '/bindCode'
    },
    {
      title: '查看报告',
      router: '/personalReport'
    }
  ]
}

const getters = {
  unFinishedQuestionnaire (state) {
    if (state.questionnaireList) {
      return state.questionnaireList.filter(aQuestionnaire => aQuestionnaire.status === 0 && new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(aQuestionnaire.endTime))
    }
  },
  scaleUnfinishedIndex (state) {
    if (state.scaleList) {
      return state.scaleList.scales.findIndex(aScale => aScale.status === 0)
    }
  }
}

const mutations = {
  setLogin (state, flag) {
    state.isLogin = flag
  },
  setFresh (state, flag) {
    state.isFresh = flag
  },
  setStudentInfo (state, studentInfo) {
    state.studentInfo = studentInfo
  },
  setQuestionnaireList (state, questionnaireList) {
    if (!questionnaireList) { return }
    questionnaireList.forEach((aQuestionnaire) => {
      aQuestionnaire.startTime = aQuestionnaire.startTime
      aQuestionnaire.endTime = aQuestionnaire.endTime
    })
    const temAdrray = questionnaireList.filter(aStartTime => new Date() > new Date(aStartTime.startTime))
    state.questionnaireList = temAdrray
  },
  setScaleList (state, scaleList) {
    scaleList.scales.sort((a, b) => {
      return a.scaleId - b.scaleId
    })
    state.scaleList = scaleList
  },
  setQuestionnaireId (state, questionnaireId) {
    state.questionnaireId = questionnaireId
  },
  setScaleStatus (state, scaleId) {
    state.scaleList.scales.forEach((answer) => {
      if (answer.scaleId === scaleId) {
        answer.status = 1
      }
    })
  },
  setNavState (state, flag) {
    state.navState = flag
  },
  setNavIndex (state, index) {
    state.navIndex = index
  },
  setIsShow (state, is) {
    state.isShowTalk = is
  },
  setCheckDate (state, systemDate) {
    let event = new Date()
    state.checkDate = Math.abs(Date.parse(systemDate) - Date.parse(event.toUTCString())) < 60 * 1000 * 60 * 12
  },
  setViewBoxState (state, flag) {
    state.isViewBox = flag
  },
  setServerError (state, errMsg) {
    state.errMsg = errMsg
  }
}

const actions = {
  // async StudentLoginToken ({ state, commit }, token) {
  //   const response = await axios.post(URL.STUDENTSLOGINTOKEN, {
  //     student_token: token.token
  //   })
  //   if (response.data.checkFlag) {
  //     commit('setStudentInfo', response.data)
  //     commit('setLogin', true)
  //     commit('setFresh', true)
  //     sessionStorage.setItem('isLogin', true)
  //     sessionStorage.setItem('studentInfo', JSON.stringify(state.studentInfo))
  //   } else {
  //     commit('setLogin', false)
  //   }
  // },
  // async StudentLogin ({ state, commit }, { type, username, password }) {
  //   const response = await axios.post(URL.STUDENTSLOGIN, {
  //     type,
  //     username,
  //     password
  //   })
  //   if (response.data.checkFlag) {
  //     commit('setStudentInfo', response.data)
  //     commit('setLogin', true)
  //     commit('setFresh', true)
  //     sessionStorage.setItem('isLogin', true)
  //     sessionStorage.setItem('studentInfo', JSON.stringify(state.studentInfo))
  //   } else {
  //     commit('setLogin', false)
  //   }
  // },
  async StaffLogin ({state, commit}, {username, password}) {
    const response = await axios.get(`${URL.STAFFLOGIN}?username=${username}&pwd=${password}`)
    if (response.data[0] && response.data[0].id) {
      commit('setStudentInfo', response.data[0])
      commit('setLogin', true)
      commit('setFresh', true)
      sessionStorage.setItem('isLogin', true)
      sessionStorage.setItem('studentInfo', JSON.stringify(state.studentInfo))
    } else {
      commit('setLogin', false)
    }
  },

  async StaffRegister ({state, commit}, {username, password, password2}) {
    const response = await axios.post(URL.STAFFREGISTER, {
      username: username,
      pwd: password,
      pwd2: password2
    })
    if (response.data.data[0] && response.data.data[0].id) {
      commit('setStudentInfo', response.data.data[0])
      commit('setLogin', true)
      commit('setFresh', true)
      sessionStorage.setItem('isLogin', true)
      sessionStorage.setItem('studentInfo', JSON.stringify(state.studentInfo))
    } else {
      commit('setLogin', false)
      if (response.data.code !== 0) {
        commit('setServerError', response.data.msg)
      }
    }
  },
  async getQuestionnaireList ({state, commit}) {
    let response = await axios.post(URL.QUESTIONGETSUMMARY, {
      studentUid: state.studentInfo.id
    })
    commit('setQuestionnaireList', response.data)
  },
  async putProfile ({state, commit}, uiobj) {
    let newObj = Object.assign({}, uiobj)
    console.log(JSON.stringify(newObj))
    await axios.post(URL.PUTPROFILE, {
      cls: 'user',
      op: 'u',
      vo: newObj
    })
    commit('setStudentInfo', newObj)
    sessionStorage.setItem('studentInfo', JSON.stringify(newObj))
  },
  async getScaleList ({state, commit}) {
    let response = await axios.post(URL.QUESTIONGETDETAIL, {
      studentUid: state.studentInfo.id,
      questionnaireId: state.questionnaireId
    })
    response.data.scales.sort(aScale => aScale.status === 0)
    commit('setScaleList', response.data)
  },
  async calculationResult ({state}, result) {
    let objId = {
      DQ_ID: state.questionnaireId,
      UID: state.studentInfo.id
    }
    let newObj = Object.assign({}, objId, result.scaleResult)
    try {
      await axios.post(URL.MIDDLE + result.scaleId, newObj)
    } catch (e) {
      console.log(e)
    }
  },
  async originalContent ({state}, result) {
    let objId = {
      DQ_ID: state.questionnaireId,
      UID: state.studentInfo.id
    }
    let newObj = Object.assign({}, objId, result.scoreObj)
    try {
      await axios.post(URL.ORIGIN + result.scaleId, newObj)
    } catch (e) {
      console.log(e)
    }
  },
  async changeStatus ({state, commit}, scaleId) {
    await axios.post(URL.CHANGERESULTSTATUS, {
      questionnaireId: state.questionnaireId,
      studentUid: state.studentInfo.id,
      scaleId: scaleId
    })
    commit('setScaleStatus', scaleId)
  }
}

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state,
  getters,
  actions,
  strict: debug,
  mutations: Object.assign({}, mutations)
})



// WEBPACK FOOTER //
// ./src/store/index.js